import BaseCache from "./cache/base-cache";
import DataUpdater from "./data-updater"
import {loadServerInit} from "./load-service"
import {loadServiceV2ServerInit} from "./load-service-v2"
import {notificationPusherInit} from "./notification-pusher"
import {contactServerInit} from "@/data-services/contact-service";
import {driverGPSServerInit} from "@/data-services/driver-gps-service";
import {configBasicServiceInit} from "@/data-services/config-basic-service";
import {commandToolsInit} from "@/data-services/command-tools";
import {systemInfo} from "@/shared-services";
const caches = {}

function getFunctionCache(name, func, $event) {
  if(!caches[name]) {
    caches[name] = new BaseCache({
      func: func,
      events: $event
    })
  }
  return caches[name]
}

function initDataService($bus) {
  BaseCache.prototype.$bus = $bus
  DataUpdater.prototype.$bus = $bus
  loadServerInit($bus)
  contactServerInit($bus)
  driverGPSServerInit($bus)
  loadServiceV2ServerInit($bus)
  configBasicServiceInit($bus)
  if(systemInfo.isCommand) {
    notificationPusherInit($bus, 600000)
  }
  commandToolsInit($bus)
}

export default {
  initDataService: initDataService,
  getFunctionCache,
}
